import { remoteConfig } from '../../config/firebase-config';
import { fetchAndActivate, getString, getNumber, getBoolean } from 'firebase/remote-config';

export const DEFAULTS = {
  prod_api_url: 'https://lastserver-deliverit-api-server-6k5m2.ondigitalocean.app',
  prod_admin_url: 'https://deliverit-admin-api-server-7ojcs.ondigitalocean.app',
  dev_admin_url: 'https://deliverit-admin-apis.tunnelto.dev',
  dev_api_url: 'https://deliverit-app-apis.tunnelto.dev',
  offer_max_value: 1000,
  offer_min_expiry_in_mins: 180,
  restrict_multiple_sign_ins: true,
  enable_sound_fx: true,
  support_whatsapp_number: '971506824339',
  admin_ids: '',
  disable_driver_tracking: false,
  disable_twilio_auth: false,
  multitenancy: false,
  show_48_hours_delivery: false,
  delivery_window_options: 'normal',
  cash_payment_enabled: false,
  cash_payment_from_reciver: false,
};

export async function fetchDynamicConfigurations() {
  if (remoteConfig) {
    remoteConfig.defaultConfig = DEFAULTS;
    try {
      await fetchAndActivate(remoteConfig);
    } catch (error) {
      // Keep cached/default values when configuration fetch fails (as mobile does).
      console.warn('Remote Config fetch failed; using cached/default values');
    }
  }
  const stringValue = (key) => (remoteConfig && getString(remoteConfig, key)) || DEFAULTS[key];
  const numberValue = (key) => remoteConfig ? getNumber(remoteConfig, key) : DEFAULTS[key];
  const booleanValue = (key) => remoteConfig ? getBoolean(remoteConfig, key) : DEFAULTS[key];
  return {
    prodApiServerBaseUrl: stringValue('prod_api_url'),
    prodAdminServerBaseUrl: stringValue('prod_admin_url'),
    devAdminServerBaseUrl: stringValue('dev_admin_url'),
    developmentApiServerBaseUrl: stringValue('dev_api_url'),
    maximumOfferValue: numberValue('offer_max_value'),
    minimumDriverOfferExpiryInMinutes: numberValue('offer_min_expiry_in_mins'),
    restrictMultipleSignIns: booleanValue('restrict_multiple_sign_ins'),
    enableSoundFx: booleanValue('enable_sound_fx'),
    supportWhatsAppNumber: stringValue('support_whatsapp_number'),
    disableDriverTracking: booleanValue('disable_driver_tracking'),
    disableTwilioAuth: booleanValue('disable_twilio_auth'),
    multitenancyEnabled: booleanValue('multitenancy'),
    show48HoursDelivery: booleanValue('show_48_hours_delivery'),
    deliveryWindowOptions: stringValue('delivery_window_options'),
    cashPaymentEnabled: booleanValue('cash_payment_enabled'),
    cashPaymentFromReceiver: booleanValue('cash_payment_from_reciver'),
  };
}
